import AppListing from 'components/pie/app_directory/show';

// When rendering the AppListing directly, there is an error when the AppListing
// has a useState call. Wrapping the component + importing React here seems to fix the issue.
// This may be related to an issue that would be fixed by upgrading
// the rails_on_react gem to v12 (https://github.com/shakacode/react_on_rails/blob/master/CHANGELOG.md#major-improvements),
// where it lists "React Hooks Support for top level components" as a change.
const AppListingWrapper = props => {
  return <AppListing {...props} />;
};

export default AppListingWrapper;
